import { environment } from '@environments/environment';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { CrudBaseService } from '../crud.service';
import { SalesApiReport, SalesFilter } from '../models/sales';
import { ApiHttp } from '@core/http/api.http';
import { Observable } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class SalesService extends CrudBaseService<SalesApiReport> {
    constructor(httpClient: HttpClient, private apiHttp: ApiHttp) {
        super(
            '/deposit-report',
            httpClient,
            environment.depositReportApiBasePath
        );
    }

    getReportData(model: SalesFilter): Observable<SalesApiReport> {
        return this.httpClient.post<SalesApiReport>(this.basePath, model);
    }
}
